var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home-load"}},[_c('h1',{staticStyle:{"padding":"0.5em"}},[_vm._v("My Records")]),_c('HomeRecordsComponent',{attrs:{"allrecords":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }